import { create } from 'zustand'
import { apiFetch } from '@/utils/api'

/**
 * Versão da app carregada de GET /api/version (source of truth: tabela app_releases).
 * Cache em memória — versão não muda durante a sessão, então só fetcha 1x.
 *
 * Fail-soft: se fetch falhar, mostra 'dev' como fallback (não quebra UI).
 */
type VersionInfo = {
  semver: string
  sha: string
  releasedAt: string | null
  changelog: string | null
}

type State = {
  info: VersionInfo
  loaded: boolean
  load: () => Promise<void>
}

const FALLBACK: VersionInfo = {
  semver: 'dev',
  sha: 'unknown',
  releasedAt: null,
  changelog: null,
}

export const useVersionStore = create<State>((set, get) => ({
  info: FALLBACK,
  loaded: false,
  load: async () => {
    if (get().loaded) return
    try {
      const data = await apiFetch<VersionInfo>('/api/version')
      set({ info: data, loaded: true })
    } catch {
      set({ info: FALLBACK, loaded: true })
    }
  },
}))
